const SelectBarChart = props => (
  <svg
    width={67}
    height={67}
    viewBox="0 0 67 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <rect width={67} height={67} rx={10} fill="white" />
      <g>
        <line y1={8.5} x2={67} y2={8.5} stroke="black" strokeOpacity={0.04} />
        <line y1={18.7} x2={67} y2={18.7} stroke="black" strokeOpacity={0.04} />
        <line y1={28.8999} x2={67} y2={28.8999} stroke="black" strokeOpacity={0.04} />
        <line y1={39.0999} x2={67} y2={39.0999} stroke="black" strokeOpacity={0.04} />
        <line y1={49.2998} x2={67} y2={49.2998} stroke="black" strokeOpacity={0.04} />
      </g>
    </g>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.3987 49.7507L33.2511 43.3193L33.2451 43.3C32.9174 42.2352 33.2339 41.1185 33.9483 40.3812C34.7623 39.5039 35.9488 39.3122 36.9299 39.6142L36.9493 39.6202L37.6549 39.8559V15.1C37.6549 13.9402 36.7146 13 35.5549 13H31.357C30.1972 13 29.257 13.9402 29.257 15.1V47.6507C29.257 48.8105 30.1972 49.7507 31.357 49.7507H35.3987ZM50.5947 44.1786V33.9996C50.5947 32.8399 49.6545 31.8996 48.4947 31.8996H44.2947C43.1349 31.8996 42.1947 32.8399 42.1947 33.9996V41.3725L50.5947 44.1786ZM24.4 47.6507C24.4 48.8105 23.4598 49.7507 22.3 49.7507H18.1C16.9402 49.7507 16 48.8105 16 47.6507V25.6C16 24.4402 16.9402 23.5 18.1 23.5H22.3C23.4598 23.5 24.4 24.4402 24.4 25.6V47.6507Z"
        fill="#B1C1C1"
      />
      <path
        d="M53.4427 47.1379L36.6767 41.5382C36.2407 41.4041 35.7714 41.5047 35.4695 41.84C35.1677 42.1418 35.0336 42.6113 35.1677 43.0471L40.7676 59.8127C41.0359 60.651 42.2095 60.718 42.5783 59.9133L45.9986 52.8047C46.0992 52.6036 46.2669 52.4359 46.4681 52.3353L53.5769 48.9151C54.3482 48.5797 54.281 47.4062 53.4427 47.1379Z"
        fill="#82868D"
      />
    </g>
  </svg>
)

export default SelectBarChart
